import { REQUEST_USERS} from '../../const';

export default function UserReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_USERS:
      return action.users;
    default:
      return state;
  }
}